import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  cardContainer: {
    backgroundColor: "#0344DC",
    borderRadius: "8px",
    margin: "15px",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "1rem 0 1rem 0",
  },
  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(30),
    color: "white",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(22),
    },
  },
  improveTitle: {
    fontFamily: "Lato",
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(18),
    color: "white",
    marginBottom: "1rem",
  },
  improveDetails: {
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    color: "white",
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(13),
    },
  },
  gamePlanTitle: {
    fontFamily: "Lato",
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(18),
    color: "white",
    marginTop: "1rem",
  },
  gamePlanContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "1.5rem",

    "& .pathDetails": {
      fontFamily: "Lato",
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(11),
      color: "#0344DC",
      lineHeight: "24px",
      textTransform: "uppercase",
    },
  },
  dashedLine: {
    borderWidth: "2px",
    borderStyle: "dashed",
    position: "absolute",
    width: "100%",
    color: "white",
  },
  disabled: {
    backgroundColor: "#688FEA",
  },
  enabled: {
    backgroundColor: "white",
    "&:hover": {
      cursor: "pointer",
    },
  },
  bulletText: {
    fontFamily: "Lato",
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(18),
    color: "#FFFFFF",
    marginLeft: "16px",
  },
  buttonContainer: {
    textAlign: "center",
  },
  button: {
    marginTop: "47px",
    backgroundColor: "transparent",
    fontFamily: "Inter",
    color: "white",
    border: "1px solid white",
    borderRadius: "100px",
    padding: "8px 30px",
    textTransform: "none",
    fontSize: theme.typography.pxToRem(16),
    alignSelf: "center",
    "& .MuiSvgIcon-root": {
      color: "#59d7ed",
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 900,
    },
    "&.MuiButton-root:hover": {
      backgroundColor: "white",
      color: "#0344dc",
    },
  },
  divider: {
    backgroundColor: "#9AB4F1",
    margin: "17px auto",
  },
  activeStateContainer: {
    marginTop: "40px",
  },
}));
